"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveRef = exports.resolveFirstItem = exports.resolveValues = exports.tryResolveModelIds = exports.resolveModelIds = exports.filterModelIds = exports.filterModelId = exports.resolveData = void 0;
const constants_1 = require("../constants");
const execute_logic_1 = __importDefault(require("./execute-logic"));
const functional_1 = require("./functional");
const reporter_1 = __importDefault(require("../reporter"));
const resolveData = (models, { index, id }) => models[index][id];
exports.resolveData = resolveData;
// HoF that accepts as its last argument an array of modelIds
// (normally from resolveQuery) and returns an array of arrays
// of the dataItems name and attr value (e.g., [dataItem.name, dataItem[attr])
const getDataFromModel = (models, attr, name) => (0, functional_1.map)(ref => {
    const dataItem = (0, exports.resolveData)(models, ref);
    return [name || dataItem.name, dataItem[attr]];
});
const filterStepChild = ({ ids, childType, model }) => (0, functional_1.pipe)(ids)((0, functional_1.map)(({ id }) => (0, functional_1.pipe)(model[id].children || [])(childType !== '*' &&
    (0, functional_1.filter)(childId => model[childId][constants_1.MODEL_TYPE] === childType), (0, functional_1.map)((childId, index) => ({ id: childId, position: index + 1 })))), functional_1.flatten);
const filterStepType = ({ ids, ast, modelIndex, models, repeatIndex }) => ids.filter(({ id, position }) => {
    const val = (0, execute_logic_1.default)({
        ast,
        data: {
            models,
            context: [{ id, index: modelIndex }],
            position,
            repeatIndex,
        },
    });
    return typeof val === 'number' ? val === position : val;
});
const filterStepIndex = ({ ids, value = 1 }) => ids.filter(({ position }) => value === position);
const filterModelId = ({ modelId, modelIndex, filterSteps = [], models = [], repeatIndex, }) => (0, functional_1.pipe)(filterSteps)((0, functional_1.reduce)((ids, step) => {
    if (step.child) {
        return filterStepChild({
            ids,
            childType: step.child,
            model: models[modelIndex],
        });
    }
    if (step.type) {
        return filterStepType({
            ids,
            ast: step,
            modelIndex,
            models,
            repeatIndex,
        });
    }
    return filterStepIndex({
        ids,
        value: step.value,
    });
}, [{ id: modelId, position: 1 }]), (0, functional_1.map)(({ id }) => ({
    index: modelIndex,
    id,
})));
exports.filterModelId = filterModelId;
const filterModelIds = ({ modelIds, filterSteps, models, repeatIndex, }) => (0, functional_1.pipe)(modelIds)((0, functional_1.map)(({ index, id: modelId }) => (0, exports.filterModelId)({
    modelId,
    modelIndex: index,
    filterSteps,
    models,
    repeatIndex,
})), functional_1.flatten);
exports.filterModelIds = filterModelIds;
const resolveModelIds = ({ modelRef, ...rest }) => {
    const { modelIds, filter: filterSteps } = modelRef;
    if (Array.isArray(modelRef))
        return (0, functional_1.pipe)(modelRef)((0, functional_1.map)(refN => (0, exports.resolveModelIds)({ modelRef: refN, ...rest })), functional_1.flatten);
    const ids = filterSteps
        ? (0, exports.filterModelIds)({ modelIds, filterSteps, ...rest })
        : modelIds;
    if (!ids)
        reporter_1.default.log(`modelRef without ids`, modelRef);
    return ids;
};
exports.resolveModelIds = resolveModelIds;
const tryResolveModelIds = ({ modelRef, ...rest }) => {
    const { modelIds, filter: filterSteps } = modelRef;
    if (Array.isArray(modelRef))
        return (0, functional_1.pipe)(modelRef)((0, functional_1.map)(refN => (0, exports.resolveModelIds)({ modelRef: refN, ...rest })), functional_1.flatten);
    const ids = filterSteps
        ? (0, exports.filterModelIds)({ modelIds, filterSteps, ...rest })
        : modelIds;
    return ids || [];
};
exports.tryResolveModelIds = tryResolveModelIds;
// Passes modelIds resolved via resolveModelIds into getDataFromModel function;
// returns an object
const resolveValues = ({ modelRef, models, name }) => {
    if (Array.isArray(modelRef)) {
        return modelRef.reduce((acc, ref) => ({
            ...acc,
            ...(0, exports.resolveValues)({ modelRef: ref, models }),
        }), {});
    }
    if (typeof modelRef.value !== 'undefined') {
        return {
            [name]: modelRef.value,
        };
    }
    return (0, functional_1.pipe)({ models, modelRef })(exports.resolveModelIds, getDataFromModel(models, modelRef.attr, name), functional_1.intoObj);
};
exports.resolveValues = resolveValues;
const resolveFirstItem = ({ modelIds }) => modelIds[0];
exports.resolveFirstItem = resolveFirstItem;
const logOnlyCount = ({ type = 'log', maxCount = 10, maxMessage }) => {
    let count = 0;
    return message => {
        count += 1;
        if (count > maxCount) {
            return;
        }
        reporter_1.default[type](message);
        if (maxMessage && count === maxCount) {
            reporter_1.default[type](maxMessage);
        }
    };
};
const warn10times = logOnlyCount({
    type: 'warn',
    maxMessage: 'Further warnings muted, please use Bind indexes instead of Bind ID.',
});
const getActiveRef = ({ bind, bindIndex, modelRef, binds }) => {
    if (bind) {
        warn10times(`Bind should no longer be used after optimization: ${bind} ${bindIndex}`);
        if (!bindIndex) {
            const foundBind = binds.find(b => b.id === bind);
            return foundBind ? foundBind.modelRef : modelRef;
        }
    }
    return bindIndex !== undefined ? binds[bindIndex].modelRef : modelRef;
};
exports.getActiveRef = getActiveRef;
//# sourceMappingURL=resolvers.js.map